import { LossLimitLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/exitTactics/LossLimitLine';
import { LossLimitTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/exits/LossLimitTacticPanel';
import { AddLossLimitTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/panels/tacticsPanel/addTacticPanel/individualAddTacticPanels/AddLossLimitTacticPanel';
import { LossLimitWrapper } from '../../../../components/displays/tradeplans/softOrderModules/exitTacticModules/LossLimitModule/wrapper/LossLimitWrapper';
import LossLimitDocs from '../../../../components/forms/tradeplans/documentation/LossLimitDocumentation';
import LossLimitModule from '../../../../components/forms/tradeplans/tradingPlanFormComponents/FieldComponents/exitTactics/modules/LossLimitModule';
import { LossLimitData } from './lossLimitData';
import { validateLossLimit } from './validateLossLimit';

export const LossLimit = {
  //data class
  dataStore: LossLimitData,

  //string constants
  name: 'LOSS_LIMIT',
  tacticLabel: 'Loss Limit',
  addTacticLabel: 'Add Loss Limit',
  category: 'Exit',

  // components
  tradePlanFormModule: LossLimitModule,
  tacticPanel: LossLimitTacticPanel,
  addTacticPanel: AddLossLimitTacticPanel,
  wrapper: LossLimitWrapper,
  chartSoftOrderComponent: LossLimitLine,
  documentation: LossLimitDocs,
  alertDetailsComponent: null,

  //functions
  setupDetailParser: null,
  validationFunction: validateLossLimit,
};
